import axios from 'axios';

const state= {
    Items:{
        data:[],
        total:0
    },
    Loadings:{
        list:false,
        create:false
    },
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
};

const actions = {
    getOrderItem({commit},params){
        commit( 'setLoadings', {key:"list",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/order-item`,{
                params: params
            })
                .then(response => {
                    commit( 'setLoadings', {key:"list",val:false});
                    resolve( response.data.data );
                })
                .catch(error => {
                    commit( 'setLoadings', {key:"list",val:false});
                    reject( error )
                });
        });
    },
    createOrderItem({commit},param){
        commit( 'setLoadings', {key:"create",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/order-item`,param)
                .then(response => {
                    commit( 'setLoadings', {key:"create",val:false});
                    resolve( response.data.data );
                })
                .catch(error => {
                    commit( 'setLoadings', {key:"create",val:false});
                    reject( error )
                });
        });
    },
    updateOrderItem({commit},param){
        commit( 'setLoadings', {key:"create",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/order-item/${param.id}`,param.data)
                .then(response => {
                    commit( 'setLoadings', {key:"create",val:false});
                    resolve( response.data.data );
                })
                .catch(error => {
                    commit( 'setLoadings', {key:"create",val:false});
                    reject( error )
                });
        });
    },
    deleteItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/order-item`, {
                data:params
            })
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    checkAmountWithBalanceBudget({commit},param){
        commit( 'setLoadings', {key:"create",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/order-item/check-balance-budget`, param)
                .then(response => {
                    commit( 'setLoadings', {key:"create",val:false});
                    resolve( response.data.data );
                })
                .catch(error => {
                    commit( 'setLoadings', {key:"create",val:false});
                    reject( error )
                });
        });
    },
};

const mutations = {
    setItems (state,data) {
        state.Items.data = data.items;
        state.Items.total = data.total;
    },
    setLoadings (state,data) {
        state.Loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}